import { render, staticRenderFns } from "./videos.vue?vue&type=template&id=07c85484&scoped=true"
import script from "./videos.vue?vue&type=script&lang=js"
export * from "./videos.vue?vue&type=script&lang=js"
import style0 from "./videos.vue?vue&type=style&index=0&id=07c85484&prod&scoped=true&lang=css"
import style1 from "./videos.vue?vue&type=style&index=1&id=07c85484&prod&lang=css"
import style2 from "./videos.vue?vue&type=style&index=2&id=07c85484&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c85484",
  null
  
)

export default component.exports